import { ApiProperty } from "@nestjs/swagger";

export class RackPositionIdRequest{
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    zoneId:number;
    @ApiProperty()
    rackId:number;
    @ApiProperty()
    rackPositionId:number;
    @ApiProperty()
    isReserved:boolean;
    @ApiProperty()
    updatedUser:string;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    varientId:number;
    // @ApiProperty()
    // minGrade:number;
    // @ApiProperty()
    // maxGrade:number;
    
}